const config = {
  api: {
    baseUrl: `${import.meta.env.VITE_E_PRESCRIBE_API_URL}`,
  },
  webSocket: {
    baseUrl: `${import.meta.env.VITE_E_PRESCRIBE_WS_URL}`,
  },
  appEnv: `${import.meta.env.VITE_ENV}`,
  apiKeys: {
  },
  showReportingCharts: false,
  rxMismatchComparisonWindow: `${import.meta.env.VITE_RX_COMPARISON_EXPIRATION_WINDOW}`,
  completedCaseCheckDeadlineInHours: `${import.meta.env.VITE_COMPLETED_CASE_CHECK_DEADLINE_IN_HOURS}`,
  showNewReportingDashboard: `${import.meta.env.VITE_SHOW_NEW_REPORTING_DASHBOARD}`,
  MARKER_PROJECT_ID: import.meta.env.VITE_MARKER_PROJECT_ID,
  LATEST_SHA: import.meta.env.VITE_LATEST_SHA,
  BUILD_ID: import.meta.env.VITE_BUILD_ID || import.meta.env.VITE_LATEST_SHA,
  RELEASE_VERSION: import.meta.env.VITE_RELEASE_VERSION,
  VERSION_MANIFEST_URL: import.meta.env.VITE_VERSION_MANIFEST_URL || '/version.json',
  USE_HEISENBERG: import.meta.env.VITE_USE_HEISENBERG,
  allowIdVerification: `${import.meta.env.VITE_ALLOW_ID_VERIFICATION}`,
  adminClientUrl: import.meta.env.VITE_ADMIN_CLIENT_URL,
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID
};

export default config;
